module.exports = __webpack_public_path__ + "img/shift.52797d1b.svg";